var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcRoundEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.125 18.1875V21.3541C3.125 21.6458 3.35417 21.875 3.64583 21.875H6.8125C6.94792 21.875 7.08333 21.8229 7.17708 21.7187L18.5521 10.3541L14.6458 6.4479L3.28125 17.8125C3.17708 17.9166 3.125 18.0416 3.125 18.1875ZM21.5729 7.33332C21.6695 7.23695 21.7461 7.12248 21.7984 6.99647C21.8506 6.87045 21.8775 6.73537 21.8775 6.59894C21.8775 6.46252 21.8506 6.32743 21.7984 6.20142C21.7461 6.0754 21.6695 5.96093 21.5729 5.86457L19.1354 3.42707C19.039 3.3305 18.9246 3.25389 18.7986 3.20162C18.6726 3.14934 18.5375 3.12244 18.401 3.12244C18.2646 3.12244 18.1295 3.14934 18.0035 3.20162C17.8775 3.25389 17.763 3.3305 17.6667 3.42707L15.7604 5.33332L19.6667 9.23957L21.5729 7.33332Z",
    fill: "url(#paint0_linear_839_1216)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_839_1216",
    x1: 3,
    y1: 3,
    x2: 179.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2596DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC319D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundEdit);
export default __webpack_public_path__ + "static/media/ic_round-edit.ba0deef9e6a60c44aa1ecf2155c3f675.svg";
export { ForwardRef as ReactComponent };